export default __webpack_public_path__ + "static/media/productMgtPreview.8365e94a.jpg";